document.addEventListener("DOMContentLoaded", function() {
  console.log('%cLoop custom logics', 'background:#000;color:#fff;', "Init");

  // 🔁 Wait for Loop widget
  function waitForLoopWidget(callback) {
    const checkExist = setInterval(() => {
      const loopContainer = document.querySelector(".loop-widget-container");
      const hasOptions = loopContainer && loopContainer.querySelectorAll(".loop-widget-purchase-option").length > 0;
      if (hasOptions) {
        clearInterval(checkExist);
        callback(loopContainer);
      }
    }, 250);
  }

  waitForLoopWidget(loopContainer => {
    const productType = window.productPurchaseType || "Single";
    console.log('%cLoop custom logics', 'background:#000;color:#fff;', "Loop widget found -", productType);

    const oneTimeOption = loopContainer.querySelector(".loop-widget-purchase-option-onetime");
    const subOption = loopContainer.querySelector('[data-loop-widget-selling-plan-group]');
    let qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
      .find(input => input.offsetParent !== null); // ✅ visible input only

    if (!oneTimeOption || !subOption || !qtyInput) {
      console.log('%cLoop custom logics', 'background:#000;color:#fff;', "No payment options found");
      return;
    }

    // --- Helpers ---
    const hide = el => { if (el) el.style.display = "none"; };
    const show = el => { if (el) el.style.display = ""; };
    const selectOption = el => {
      if (el && !el.classList.contains("loop-widget-purchase-option-selected")) el.click();
    };

    if (productType == 'Bundle' || productType == 'Starter Bundle' || productType == 'Single') {
      selectOption(subOption);
      const optionsContainer = loopContainer.querySelector(".loop-widget-purchase-options-container");
      if (optionsContainer) {
        optionsContainer.style.display = "flex";
        optionsContainer.style.flexDirection = "column-reverse";
      }
    }


    //inject freegift html and badge
    const freeGift = document.createElement("div");
    freeGift.className = "loop-freegift";
    freeGift.style.display = "none";

    const badge = document.createElement("span");
    badge.className = "loop-badge";
    badge.style.display = "none";

    const headingContainer = document.querySelector('.product-form--block[data-block-type="heading"]');

    if (productType == 'Starter Bundle') {
      freeGift.innerHTML = `
        <div class="text">
          You've unlocked <br/> a free rini headband!
        </div>
        <div class="image">
          <img src="https://cdn.shopify.com/s/files/1/0893/2746/8728/files/freeheadband.png?v=1763036838" />
        </div>
      `;
      loopContainer.appendChild(freeGift);

      badge.textContent = '33% off';
      headingContainer.appendChild(badge);


      //add 33% off badge
      const badgeWrapper = subOption.querySelector('.loop-widget-spg-label-discount-wrapper');
       const offbadge = document.createElement('div');
       offbadge.textContent = '33% off';

       offbadge.style.borderRadius = '30px';
       offbadge.style.background = '#EDF9B3';
       offbadge.style.padding = '2px 7px';
       offbadge.style.fontWeight = '500';

       badgeWrapper.appendChild(offbadge);
    }
 

    // --- Descriptions (based on product type) ---
    let subDesc = "";
    let oneTimeDesc = "";

    if (productType === "Single") {
      qtyInput.value = 5;
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));

      // For single SKU
      subDesc = `<ul class="loop-desc">
          <li>buy 5+ to subscribe</li>
          <li>save 10% off every month</li>
          <li>skip, pause, or cancel anytime</li>
        </ul>`;
      oneTimeDesc = ""; // optional – no one-time description for singles
    }

    else if (productType === "Starter Bundle") {
      subDesc = `<ul class="loop-desc">
          <li>2 hydrogel facial masks shipped monthly</li>
          <li>3 everyday facial sheet masks shipped monthly</li>
          <li><b>free</b> rini headband one-time shipment</li>
          <li>pause, cancel, or adjust at anytime</li>
        </ul>`;
      oneTimeDesc = `<ul class="loop-desc">
          <li>2 hydrogel facial masks</li>
          <li>3 everyday facial sheet masks</li>
          <li class="no">no free headband</li>
        </ul>`;
    }

    else if (productType === "Bundle") {
      subDesc = `<ul class="loop-desc">
          <li>save an additional 10% off every month</li>
          <li>skip, pause, or cancel anytime</li>
        </ul>`;
      oneTimeDesc = ``;
    }

    else if (productType === "Bundle with subscription only") {
      subDesc = ``;
      oneTimeDesc = "";
    }

    // --- Create elements (shared logic) ---
    const oneTimeDescEl = document.createElement("div");
    oneTimeDescEl.innerHTML = oneTimeDesc;
    oneTimeDescEl.classList.add("loop-desc-wrapper");

    const subDescEl = document.createElement("div");
    subDescEl.innerHTML = subDesc;
    subDescEl.classList.add("loop-desc-wrapper");

    // --- Shared styles ---
    const style = document.createElement("style");
    style.textContent = `
      .loop-widget-container .loop-desc-wrapper {
        margin-left: 2em;
        width: fill-available;
        font-size:13px;
        line-height:1.5;
        align-self: flex-start;
        display:none;
      }

      .loop-widget-purchase-option-selected .loop-desc-wrapper{
        display:block;
      }
      
      .loop-widget-container .loop-desc li {
        padding-left:20px;
        position: relative;
        margin-top:5px;
        font-weight: 500;
        text-align:left;
      }

      
      .loop-widget-container .loop-desc li::before {
        content: url(check.svg);
        position: absolute;
        left: 0;
        top: 0;
      }

      .loop-widget-container .loop-desc.no::before {
          content: url(Union.svg);
      }
    `;
    if (!document.getElementById("loop-custom-style")) {
      style.id = "loop-custom-style";
      document.head.appendChild(style);
    }


    oneTimeOption.appendChild(oneTimeDescEl);
    subOption.appendChild(subDescEl);
    const spgContainer = subOption.querySelector(".loop-widget-spg-container");
    if (spgContainer) spgContainer.style.display = "none";
    

    const toggleDescVisibility = () => {
      const isSubSelected = subOption.classList.contains("loop-widget-purchase-option-selected");
      oneTimeDescEl.style.display = isSubSelected ? "none" : "flex";
      subDescEl.style.display = isSubSelected ? "flex" : "none";
    };

    // ----- PRODUCT MEDIA SWITCHER ----- reversed the images on dec 17, 2025
    const mainGallery = document.querySelector('.main-product--desktop:not([data-type="optional"])');
    const optionalGallery = document.querySelector('.main-product--desktop[data-type="optional"]');
    const mainGalleryMobile = document.querySelector('.main-product--mobile:not([data-type="optional"])');
    const optionalGalleryMobile = document.querySelector('.main-product--mobile[data-type="optional"]');
    const subBtn = document.querySelector('.product-buy-buttons--primary:not([disabled]) .product-buy-buttons--cta-text');

    // only run switching logic if optional gallery exists
    const hasOptionalGallery = optionalGallery !== null;

    // Helper to show/hide galleries
    function updateGalleryBasedOnSelection() {
      if (!hasOptionalGallery) return;  // <-- required

      if (productType === "Starter Bundle") {
        const isSubSelected = subOption.classList.contains("loop-widget-purchase-option-selected");

        if (isSubSelected) {
          // subscription selected → show main gallery
          /*
          if (mainGallery) mainGallery.style.display = "";
          optionalGallery.style.display = "none";

          if (mainGalleryMobile) mainGalleryMobile.style.display = "";
          optionalGalleryMobile.style.display = "none";
          */

          mainGallery.style.display = "none";
          optionalGallery.style.display = "";

          mainGalleryMobile.style.display = "none";
          optionalGalleryMobile.style.display = "";

          freeGift.style.display = "";
          badge.style.display = "";
          if(subBtn) { subBtn.textContent = "try it now"; }
        } else {
          // one-time selected → show optional gallery
          /*
          if (mainGallery) mainGallery.style.display = "none";
          optionalGallery.style.display = "";

          if (mainGalleryMobile) mainGalleryMobile.style.display = "none";
          optionalGalleryMobile.style.display = "";
          */

          mainGallery.style.display = "";
          optionalGallery.style.display = "none";

          mainGalleryMobile.style.display = "";
          optionalGalleryMobile.style.display = "none";

          freeGift.style.display = "none";
          badge.style.display = "none";
        }
      }
    }

    // --- Debounced update logic ---
    let updateTimer;
    function updateOptionsDebounced() {
      clearTimeout(updateTimer);
      updateTimer = setTimeout(updateOptions, 100); // small delay fixes race
    }

    function updateOptions() {
      qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
        .find(input => input.offsetParent !== null);

      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      show(subOption);
      show(oneTimeOption);

      if (productType == "Single") {
        const isSubSelected = subOption.classList.contains("loop-widget-purchase-option-selected");
        // revert when manually reduce qty < 4
        if (isSubSelected && qty < 5) {
          selectOption(oneTimeOption);
        }
      } else if (productType == "Bundle") {
        show(subOption); show(oneTimeOption);
      } else if (productType == "Starter Bundle") {
        show(subOption); show(oneTimeOption); toggleDescVisibility();
      } else if (productType == "Bundle with subscription only") {
        hide(oneTimeOption); show(subOption); selectOption(subOption);
      }

      updateGalleryBasedOnSelection();
      window.dispatchEvent(new CustomEvent('bundle:update'));
    }

    // --- Hover + click logic for Single ---
    if (productType == "Single") {
      const subLabelEl = subOption.querySelector(".loop-widget-purchase-option-label");
      const originalText = subLabelEl ? subLabelEl.textContent : "";

      subOption.addEventListener("mouseenter", () => {
        if (subLabelEl) subLabelEl.textContent = "buy 5+ to subscribe";
      });
      subOption.addEventListener("mouseleave", () => {
        if (subLabelEl) subLabelEl.textContent = originalText;
      });

      subOption.addEventListener("click", () => {
        qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
          .find(input => input.offsetParent !== null);
        const qty = parseInt(qtyInput.value, 10) || 1;

        if (qty < 5) {
          qtyInput.value = 5;
          qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
          qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
          console.log("%cLoop custom logics", "background:#000;color:#fff;", "Qty auto-adjusted to 5 for subscription");
        }
      });
    }

    // --- Bindings ---
    updateOptions();

    if (qtyInput) {
      qtyInput.addEventListener("input", updateOptionsDebounced);
      qtyInput.addEventListener("change", updateOptionsDebounced);
    }

    const plusBtn = document.querySelector(".quantity-selector--plus");
    const minusBtn = document.querySelector(".quantity-selector--minus");
    const handleQtyButtonClick = () => setTimeout(updateOptionsDebounced, 100);

    if (plusBtn) plusBtn.addEventListener("click", handleQtyButtonClick);
    if (minusBtn) minusBtn.addEventListener("click", handleQtyButtonClick);

    const observerQty = new MutationObserver(updateOptionsDebounced);
    if (qtyInput) observerQty.observe(qtyInput, { attributes: true, attributeFilter: ["value"] });

    const observer = new MutationObserver(() => {
      updateOptionsDebounced();
      qtyInput = Array.from(document.querySelectorAll('input[name="quantity"]'))
        .find(input => input.offsetParent !== null);
    });
    observer.observe(loopContainer, { childList: true, subtree: true });
  });
});